export default {
  baseURL: 'https://api.frotas-hml.ares-saude.com.br/api/v1/',
  normalURL: 'https://api.frotas-hml.ares-saude.com.br',
  mapApikey: 'AIzaSyDLn0rtU25-udA0WAACua5y7dzV8U-7MDc',
  consultApi: 'http://chronos.it4d.com.br/chronos/consult_position.php?placa=',
  localURL: 'https://frotas-hml.ares-saude.com.br',
  wsHost: 'ws.frotas-hml.ares-saude.com.br',
  wsPort: 443,
  wsKey: 'ka4vqwrpnksj28rvjufs',
  wsForceTLS: true,
}
